module.exports = __webpack_public_path__ + "img/titles-bg.cedf40f6.svg";